import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface PdfViewerOptions {
  /** Источник PDF — сетевой URL или Blob */
  source: string | Blob;
  /** Имя файла с расширением, отображается в заголовке и используется при скачивании */
  filename: string;
}

/**
 * Сервис-шина для открытия встроенного просмотрщика PDF.
 *
 * Хост-компонент PdfViewerDialogComponent подписывается на open$
 * и открывает общий dialog c pdf.js viewer.
 *
 * Использование:
 *   pdfViewerService.open({ source: blob, filename: 'document.pdf' });
 */
@Injectable({
  providedIn: 'root',
})
export class PdfViewerService {
  /** Поток запросов на открытие PDF — слушает PdfViewerDialogComponent */
  readonly open$ = new Subject<PdfViewerOptions>();

  open(options: PdfViewerOptions): void {
    this.open$.next(options);
  }
}
